import { render, staticRenderFns } from "./chapters.vue?vue&type=template&id=013066a2&scoped=true"
import script from "./chapters.vue?vue&type=script&lang=js"
export * from "./chapters.vue?vue&type=script&lang=js"
import style0 from "./chapters.vue?vue&type=style&index=0&id=013066a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013066a2",
  null
  
)

export default component.exports